/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SubscriptionInputs */

const en_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const es_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción`)
};

const fr_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const de_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const ja_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション`)
};

const zh_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅制`)
};

const ar_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراك`)
};

const id_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlangganan`)
};

const it_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonamento`)
};

const ru_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка`)
};

const pt_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinatura`)
};

const ko_val_subscription = /** @type {(inputs: Val_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독형`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Val_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_subscription = /** @type {((inputs?: Val_SubscriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SubscriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_subscription(inputs)
	if (locale === "es") return es_val_subscription(inputs)
	if (locale === "fr") return fr_val_subscription(inputs)
	if (locale === "de") return de_val_subscription(inputs)
	if (locale === "ja") return ja_val_subscription(inputs)
	if (locale === "zh") return zh_val_subscription(inputs)
	if (locale === "ar") return ar_val_subscription(inputs)
	if (locale === "id") return id_val_subscription(inputs)
	if (locale === "it") return it_val_subscription(inputs)
	if (locale === "ru") return ru_val_subscription(inputs)
	if (locale === "pt") return pt_val_subscription(inputs)
	return ko_val_subscription(inputs)
});